
import { Footer } from '../../components/share/Footer';
import { NavbarComponent } from "../../components/share/NavbarComponent";
import { HeadTitle } from "../../components/share/HeadTitle";
import { CreateAttatchFileFormTestComponent } from '../../components/Officer/CreateAttatchFileFormTestComponent';
import React from 'react'

export const CreateAttatchFileFormTestContainer = () => {
  const titleName = "แผนที่ตั้งของสถานที่ดำเนินการทดสอบมาตรฐานฝีมือแรงงาน";
  return (
    <div className="page-container bg-landing">

      <NavbarComponent />
      <HeadTitle title={titleName} />
      <CreateAttatchFileFormTestComponent />
      <Footer />
    </div>
  );
}
